import api from "./client";

export async function getClinikoStatus() {
  const res = await api.get("/cliniko/status");
  return res.data;
}

export async function connectCliniko(payload: {
  base_url: string;
  api_key: string;
}) {
  const res = await api.post("/cliniko/connect", payload);
  return res.data;
}

export async function disconnectCliniko() {
  const res = await api.post("/cliniko/disconnect");
  return res.data;
}
